import React, { useState, useEffect } from 'react';
import { Container, Table, Button, Badge, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { FiPlus, FiUsers, FiEdit2, FiArrowLeft, FiShield } from 'react-icons/fi';
import { Can } from '../config/ability';

const UserManagement = () => {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const res = await api.get('/users');
            setUsers(res.data);
        } catch (err) {
            console.error('Erro ao buscar usuários', err);
        }
    };

    return (
        <Container className="mt-4 mb-5">
            <div className="d-flex align-items-center mb-4">
                <Button 
                    variant="link" 
                    as={Link} 
                    to="/dashboard" 
                    className="text-decoration-none p-0 mb-2 text-muted"
                >
                    <FiArrowLeft className="me-1" /> Voltar para Dashboard
                </Button>                
            </div>
            <div className="d-flex justify-content-between align-items-center">
                    <h2 className="mb-4 fw-bold" style={{ fontFamily: 'Nunito, sans-serif', color: '#006064' }}>
                        Gestão de Usuários
                    </h2>
                    <div className="d-flex gap-2">
                        <Can I="manage" a="Profile">
                            <Button variant="outline-primary" as={Link} to="/profiles" className="fw-bold d-flex align-items-center gap-2">
                                <FiShield /> Perfis de Acesso
                            </Button>
                        </Can>
                        <Button variant="success" as={Link} to="/users/new" className="fw-bold d-flex align-items-center gap-2">
                            <FiPlus /> Novo Usuário
                        </Button>
                    </div>
                </div>
            <Card className="shadow-sm border-0">
                <Card.Body className="p-0">
                    <Table hover responsive className="mb-0 align-middle">
                        <thead className="bg-light">
                            <tr>
                                <th className="border-0 text-secondary small fw-bold text-uppercase ps-4 opacity-7">Nome</th>
                                <th className="border-0 text-secondary small fw-bold text-uppercase opacity-7">Email</th>
                                <th className="border-0 text-secondary small fw-bold text-uppercase opacity-7">Perfil</th>
                                <th className="border-0 text-secondary small fw-bold text-uppercase text-end pe-4 opacity-7">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(u => (
                                <tr key={u.id}>
                                    <td className="ps-4 fw-bold text-dark">{u.nome}</td>
                                    <td className="text-muted">{u.email}</td>
                                    <td>
                                        <Badge 
                                            bg={(u.profile_nome || u.perfil) === 'Administrador' ? 'danger' : 'info'} 
                                            className="fw-normal px-3 py-2 rounded-pill text-uppercase"
                                            style={{ letterSpacing: '0.5px' }}
                                        >
                                            {u.profile_nome || u.perfil}
                                        </Badge>
                                    </td>
                                    <td className="text-end pe-4">
                                        <Button size="sm" variant="link" className="text-primary p-0 text-decoration-none" as={Link} to={`/users/${u.id}/edit`}>
                                            <FiEdit2 size={18} />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            {users.length === 0 && (
                                <tr>
                                    <td colSpan="4" className="text-center py-4 text-muted">
                                        Nenhum usuário encontrado.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default UserManagement;
